/**
 * @generated SignedSource<<c01fb98eddbfef4f385830e8db1d4cce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdatePanelistInput = {
  clientMutationId?: string | null;
  data: any;
  panelistId: string;
};
export type FormPanelistResponses_UpdatePanelist_Mutation$variables = {
  input: UpdatePanelistInput;
};
export type FormPanelistResponses_UpdatePanelist_Mutation$data = {
  readonly updatePanelist: {
    readonly panelist: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"FormPanelistResponses_panelist">;
    };
  };
};
export type FormPanelistResponses_UpdatePanelist_Mutation = {
  response: FormPanelistResponses_UpdatePanelist_Mutation$data;
  variables: FormPanelistResponses_UpdatePanelist_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userSpecified",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormPanelistResponses_UpdatePanelist_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePanelistPayload",
        "kind": "LinkedField",
        "name": "updatePanelist",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PanelistNode",
            "kind": "LinkedField",
            "name": "panelist",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FormPanelistResponses_panelist"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormPanelistResponses_UpdatePanelist_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePanelistPayload",
        "kind": "LinkedField",
        "name": "updatePanelist",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PanelistNode",
            "kind": "LinkedField",
            "name": "panelist",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SelectedResponse",
                "kind": "LinkedField",
                "name": "selectedResponses",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CharacteristicNode",
                    "kind": "LinkedField",
                    "name": "characteristic",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicElementMetaNode",
                        "kind": "LinkedField",
                        "name": "elementMeta",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "responseValidation",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "target",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "target2",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicAnswerNode",
                        "kind": "LinkedField",
                        "name": "answers",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicRowNode",
                        "kind": "LinkedField",
                        "name": "rows",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CharacteristicResponseNode",
                    "kind": "LinkedField",
                    "name": "characteristicResponses",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicAnswerNode",
                        "kind": "LinkedField",
                        "name": "answer",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customAnswer",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicRowNode",
                        "kind": "LinkedField",
                        "name": "row",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "textValue",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "817ddd6a9accfdc60a086f8456e2ddc5",
    "id": null,
    "metadata": {},
    "name": "FormPanelistResponses_UpdatePanelist_Mutation",
    "operationKind": "mutation",
    "text": "mutation FormPanelistResponses_UpdatePanelist_Mutation(\n  $input: UpdatePanelistInput!\n) {\n  updatePanelist(input: $input) {\n    panelist {\n      id\n      ...FormPanelistResponses_panelist\n    }\n  }\n}\n\nfragment FormItemCharacteristicResponses_characteristic on CharacteristicNode {\n  id\n  elementMeta {\n    responseValidation\n    target\n    target2\n  }\n  text\n  type\n  ...InputCharacteristicResponses_characteristic\n}\n\nfragment FormItemCharacteristicResponses_characteristicResponses on CharacteristicResponseNode {\n  ...InputCharacteristicResponses_characteristicResponses\n  answer {\n    id\n  }\n  customAnswer\n}\n\nfragment FormPanelistResponses_panelist on PanelistNode {\n  id\n  selectedResponses {\n    characteristic {\n      id\n      text\n      type\n      ...FormItemCharacteristicResponses_characteristic\n    }\n    characteristicResponses {\n      answer {\n        id\n        userSpecified\n      }\n      customAnswer\n      row {\n        id\n      }\n      textValue\n      ...FormItemCharacteristicResponses_characteristicResponses\n      id\n    }\n  }\n}\n\nfragment InputCharacteristicResponseDate_characteristic on CharacteristicNode {\n  id\n}\n\nfragment InputCharacteristicResponseDate_characteristicResponses on CharacteristicResponseNode {\n  id\n  textValue\n}\n\nfragment InputCharacteristicResponseGridSingleSelect_characteristic on CharacteristicNode {\n  id\n  answers {\n    id\n    text\n  }\n  rows {\n    id\n    text\n  }\n}\n\nfragment InputCharacteristicResponseGridSingleSelect_characteristicResponses on CharacteristicResponseNode {\n  id\n  answer {\n    id\n  }\n  row {\n    id\n  }\n}\n\nfragment InputCharacteristicResponseMultiSelect_characteristic on CharacteristicNode {\n  id\n  answers {\n    id\n    text\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponseMultiSelect_characteristicResponses on CharacteristicResponseNode {\n  id\n  customAnswer\n  answer {\n    id\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponseNumber_characteristic on CharacteristicNode {\n  id\n  elementMeta {\n    responseValidation\n    target\n    target2\n  }\n}\n\nfragment InputCharacteristicResponseNumber_characteristicResponses on CharacteristicResponseNode {\n  id\n  textValue\n}\n\nfragment InputCharacteristicResponseOpenEnd_characteristic on CharacteristicNode {\n  id\n}\n\nfragment InputCharacteristicResponseOpenEnd_characteristicResponses on CharacteristicResponseNode {\n  id\n  textValue\n}\n\nfragment InputCharacteristicResponseSingleSelect_characteristic on CharacteristicNode {\n  id\n  answers {\n    id\n    text\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponseSingleSelect_characteristicResponses on CharacteristicResponseNode {\n  id\n  customAnswer\n  answer {\n    id\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponses_characteristic on CharacteristicNode {\n  type\n  ...InputCharacteristicResponseDate_characteristic\n  ...InputCharacteristicResponseGridSingleSelect_characteristic\n  ...InputCharacteristicResponseMultiSelect_characteristic\n  ...InputCharacteristicResponseNumber_characteristic\n  ...InputCharacteristicResponseOpenEnd_characteristic\n  ...InputCharacteristicResponseSingleSelect_characteristic\n}\n\nfragment InputCharacteristicResponses_characteristicResponses on CharacteristicResponseNode {\n  ...InputCharacteristicResponseDate_characteristicResponses\n  ...InputCharacteristicResponseGridSingleSelect_characteristicResponses\n  ...InputCharacteristicResponseMultiSelect_characteristicResponses\n  ...InputCharacteristicResponseNumber_characteristicResponses\n  ...InputCharacteristicResponseOpenEnd_characteristicResponses\n  ...InputCharacteristicResponseSingleSelect_characteristicResponses\n}\n"
  }
};
})();

(node as any).hash = "c21fcae28fea3bc4d5aec363dcbbeba4";

export default node;
